import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
export const DEFAULT_TABLE_PAGINATION = { skip: 0, take: 50 };
const DEFAULT_TABLE_CONFIG = {
    pagination: DEFAULT_TABLE_PAGINATION,
};
const TableConfigContext = createContext(DEFAULT_TABLE_CONFIG);
export function TableConfigProvider({ pagination, formatError, children, }) {
    const value = useMemo(() => ({
        pagination: pagination ?? DEFAULT_TABLE_PAGINATION,
        formatError,
    }), [pagination, formatError]);
    return (_jsx(TableConfigContext.Provider, { value: value, children: children }));
}
export function useTableConfig() {
    return useContext(TableConfigContext);
}
//# sourceMappingURL=table-config.js.map